/**
 * Codes des types de document de vente, tels que le serveur les sert dans
 * `SalesDocumentType.code` — devis, facture, avoir.
 *
 * À préférer aux lettres nues (`'D'`, `'F'`, `'A'`) partout où le code décide de quelque
 * chose : un `documentType="Quotation"` se lit, un `documentType="D"` se devine.
 */
export enum SalesDocumentTypeEnum {
    Quotation = 'D',
    Invoice = 'F',
    CreditNote = 'A',
}
